'use client'
import Image from 'next/image'
import { Configure, InstantSearch } from 'react-instantsearch'
import Filters from '../layout/search/filters'
import FilterLabels from '../layout/search/filtersLabels'
import { searchClient } from '../layout/search/typesenseAdapter'
import HomeSearchBar from './homeSearchBar'
import { CANARY_MISSION, TYPESENSE_INDEX } from '@/enum/enum'

export const SearchSection = () => {
  return (
    <div className="w-full bg-white sm:!pt-[100px] pt-[50px] flex justify-center">
      <div className="lg:w-[70vw] sm:w-[90vw] w-full">
        <div className="flex flex-col 2xl:grid 2xl:grid-cols-3 sm:gap-12 2xl:items-start">
          <div className="col-span-1 flex flex-col">
            <h2 className="text-3xl font-bold text-black leading-tight sm:mb-4 pl-5 sm:pl-0">
              Use Our Data Driven Search
            </h2>
            <p className="hidden sm:block text-lg text-black leading-relaxed">
              {CANARY_MISSION.NAME}&apos; database includes profiles of students, professors and
              professionals who have expressed anti-American or antisemitic sentiments. Use our
              data-driven search to protect yourself, your business, and your future.
            </p>
          </div>

          <div className="block sm:hidden">
            <SearchSuggestions />
          </div>

          <div className="bg-[#D9D9D9] sm:bg-white col-span-2 flex flex-col gap-6 justify-self-center sm:mx-0 md:px-8 px-5 sm:p-0 pt-5">
            <InstantSearch searchClient={searchClient} indexName={TYPESENSE_INDEX}>
              <Configure hitsPerPage={0} />
              <div className="bg-[#D9D9D9] h-[77px] justify-center flex flex-col self-center px-[20px] sm:rounded-lg sm:border sm:border-[#4B5563] w-fit">
                <HomeSearchBar />
              </div>
              <p className="text-black font-medium self-center">
                Use filters to narrow your results.
              </p>
              <div className="flex flex-col sm:w-full justify-center ">
                <Filters isHomePage={true} />
                <div className="mb-[10px] max-h-[75px] h-[75px] overflow-y-auto">
                  <FilterLabels />
                </div>
              </div>
            </InstantSearch>
          </div>
        </div>

        <div className="hidden sm:block">
          <SearchSuggestions />
        </div>
      </div>
    </div>
  )
}

const SearchSuggestions = () => {
  return (
    <div className="pt-8 pb-8 grid grid-cols-1 md:grid-cols-4 sm:grid-cols-2 md:gap-12 gap-6 justify-items-center text-lg font-medium">
      <span className="flex items-center gap-2">
        <Image
          src={'/images/favicons/person-info-card.svg'}
          alt={'person-card'}
          width={38}
          height={30}
        />
        <p className="mt-1">Search Your New Hire</p>
      </span>

      <span className="flex items-center gap-2 max-w-[230px]">
        <Image
          src={'/images/favicons/check-plus-circle.svg'}
          alt={'check-plus'}
          width={30}
          height={30}
        />
        <p className="mt-1">Verify Your Medical Professional</p>
      </span>

      <span className="flex items-center gap-2">
        <Image
          src={'/images/favicons/question-circle.svg'}
          alt={'question-circle'}
          width={30}
          height={30}
        />
        <p className="mt-1">Check Your Professor</p>
      </span>

      <span className="flex items-center gap-2">
        <Image
          src={'/images/favicons/info-outline.svg'}
          alt={'info-circle'}
          width={30}
          height={30}
        />
        <p className="mt-1">Find an Organization</p>
      </span>
    </div>
  )
}

export default SearchSection
